<button class="btn btn-primary mb-1" [disabled]="!isEnabled || !hasPermission || isBlocked" (click)="manualCallTicket()" title="{{ tooltipTitle }}" #button>
    <span class="element-text">{{ getButtonTitleTranslateTag() | translate }}</span>
</button>
